import {
  ComponentType,
  ExoticComponent,
  Fragment,
  lazy,
  ReactNode,
} from 'react';

export const shouldLoadAuth = () =>
  process.env.GATSBY_LOGIN_REGISTER_ENABLED === 'true';

export const importAuthComponent = <T extends any, K extends any>(
  factory: () => Promise<T>,
  fun: (c: T) => {
    default: ComponentType<K>;
  } = (c) => ({
    // @ts-ignore
    default: c.default,
  }),
  fallback: ExoticComponent<{
    children?: ReactNode | undefined;
  }> = Fragment
) => (shouldLoadAuth() ? lazy(() => factory().then(fun)) : fallback);
